<template>
  <path d="M31.878 16.382a15.005 15.005 0 0 0-12.95 7.483c-.23.39-.23.88 0 1.27a15.005 15.005 0 0 0 12.95 7.482c5.324 0 10.284-2.869 12.95-7.482.23-.39.23-.88 0-1.27a15.005 15.005 0 0 0-12.95-7.483Zm0 12.816A4.703 4.703 0 0 1 27.18 24.5a4.703 4.703 0 0 1 4.698-4.698 4.703 4.703 0 0 1 4.698 4.698 4.703 4.703 0 0 1-4.698 4.698Z"/>
</template>
